import React, { useMemo } from 'react';
import { Select } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';
import useGroup from '../zustand/useGroup';
import useReportLog from '../hooks/useReportLog';
import styled from 'styled-components';

const TIMEZONES = [7, 8, 9];

const TimezoneSelector: React.FC = () => {
  const { timezone, setTimezone, browserTimezone } = useGroup();
  const { setLogs } = useReportLog();

  const timezoneOptions = useMemo(() => {
    const values = Array.from(
      new Set([...TIMEZONES, browserTimezone])
    ).sort((a, b) => a - b);

    return values.map((value) => ({
      value,
      label: `GMT${value >= 0 ? '+' : ''}${value}${
        value === browserTimezone ? ' (Default)' : ''
      }`,
    }));
  }, [browserTimezone]);

  const handleTimezoneChange = (value: number) => {
    setLogs({});
    setTimezone(value);
  };

  return (
    <StyledSelectContainer>
      <Select
        value={timezone}
        onChange={handleTimezoneChange}
        options={timezoneOptions}
        placeholder="Select Timezone"
        suffixIcon={<ClockCircleOutlined />}
        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
      />
    </StyledSelectContainer>
  );
};

const StyledSelectContainer = styled.div`
  display: flex;
  align-items: center;

  .ant-select {
    width: 140px;

    @media (max-width: 767px) {
      width: 120px;
    }

    .ant-select-selector {
      border-radius: 8px;
      border: 1px solid #d9d9d9;
      
      &:hover {
        border-color: #4096ff;
      }
    }
  }
`;

export default TimezoneSelector;
